/**
 * Promo Bar – Mobile slider with arrow toggle & swipe
 *
 * On mobile (< 750px):
 *  - Slides right→left every 7s, then back left→right (ping-pong)
 *  - Arrow button advances to next slide on tap
 *  - Swipe left/right to navigate manually
 *  - Arrow disappears after the first slide
 */
(function () {
    'use strict';

    var INTERVAL = 7000;
    var MOBILE_BREAKPOINT = 750;
    var SWIPE_THRESHOLD = 40;

    function init() {
        var container = document.querySelector('.promo-bar__container');
        if (!container) return;

        var items = container.querySelectorAll('.promo-bar__item');
        if (items.length <= 1) return;

        var currentIndex = 0;
        var direction = 1;
        var timer = null;
        var arrowHidden = false;
        var touchStartX = 0;

        // Create arrow indicator
        var arrow = document.createElement('span');
        arrow.className = 'promo-bar__arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
        container.appendChild(arrow);

        function isMobile() {
            return window.innerWidth < MOBILE_BREAKPOINT;
        }

        function updateArrow() {
            // Brief fade out, swap side, fade back in
            arrow.style.opacity = '0';
            setTimeout(function () {
                if (direction === -1) {
                    arrow.style.right = 'auto';
                    arrow.style.left = '6px';
                    arrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
                    arrow.style.animation = 'promo-arrow-nudge-left 1.4s ease-in-out infinite';
                } else {
                    arrow.style.left = 'auto';
                    arrow.style.right = '6px';
                    arrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
                    arrow.style.animation = 'promo-arrow-nudge-right 1.4s ease-in-out infinite';
                }
                arrow.style.opacity = '1';
            }, 200);
        }

        function updateSlide() {
            var offset = -currentIndex * 100;
            for (var i = 0; i < items.length; i++) {
                items[i].style.transform = 'translateX(' + offset + '%)';
            }
            updateArrow();
        }

        function goTo(index) {
            if (index < 0) index = 0;
            if (index >= items.length) index = items.length - 1;
            currentIndex = index;
            // Keep direction in sync with position
            direction = (currentIndex >= items.length - 1) ? -1 : 1;
            updateSlide();
        }

        function advance() {
            if (currentIndex + direction >= items.length) {
                direction = -1;
            } else if (currentIndex + direction < 0) {
                direction = 1;
            }
            currentIndex += direction;
            // Sync direction for arrow position based on where we are now
            if (currentIndex >= items.length - 1) {
                direction = -1;
            } else if (currentIndex <= 0) {
                direction = 1;
            }
            updateSlide();
        }

        function hideArrow() {
            if (!arrowHidden) {
                arrowHidden = true;
                arrow.classList.add('is-hidden');
            }
        }

        function startRotation() {
            stopRotation();
            updateSlide();
            timer = setInterval(advance, INTERVAL);
        }

        function stopRotation() {
            if (timer) {
                clearInterval(timer);
                timer = null;
            }
        }

        // Arrow click → advance in current direction
        arrow.addEventListener('click', function (e) {
            e.preventDefault();
            stopRotation();
            advance();
            setTimeout(startRotation, 2000);
        });

        // Swipe support
        container.addEventListener('touchstart', function (e) {
            touchStartX = e.touches[0].clientX;
            stopRotation();
        }, { passive: true });

        container.addEventListener('touchend', function (e) {
            var diff = touchStartX - e.changedTouches[0].clientX;
            if (Math.abs(diff) > SWIPE_THRESHOLD) {
                // Swipe left → next, swipe right → prev
                goTo(currentIndex + (diff > 0 ? 1 : -1));
            }
            setTimeout(startRotation, 2000);
        }, { passive: true });

        // Init – run on all screen sizes
        startRotation();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
